import { IconDropDownButton } from "@etframework/ui.components";
import "moment/dist/locale/es-us";
import { useTranslation } from "react-i18next";
import { formatDate, formatDateFromNow } from "../../utils/helpers";
import { DateFormats } from "../../types/DateFormats";
import jsPDF from "jspdf";
import { Comments } from "./Comments";
import { useComments } from "../../data/queries/commentQueries";

export const CommentsContainer = ({ task }) => {
  const { t, i18n } = useTranslation(["Overlay", "Shared"]);
  const { data: comments, refetch: refetchComments } = useComments(task?.Id);
  const onSelectDropDownTaskMenu = (args) => {
    args?.item?.onClick?.();
  };

  const dropdownMenu = [
    {
      id: "moreactions-print",
      text: t("Print"),
      iconCss: "fa-regular fa-print",
      onClick: () => {
        const doc = new jsPDF();
        const margin = 20,
          maxWidth = 170,
          lineHeight = 10,
          userInfoSpacing = 5;
        let yOffset = 15;

        const addPageIfNeeded = (height) => {
          if (yOffset + height > doc.internal.pageSize.height) {
            doc.addPage();
            yOffset = 20;
          }
        };

        doc.setFillColor(240, 240, 240); // Light gray background color for the container
        doc.rect(margin - 5, yOffset - 5, maxWidth + 5 * 2, 30, "F"); // Adjust height as needed

        doc.setFontSize(10).text(`${t("Comments")}`, margin, yOffset);
        yOffset += 10;
        doc
          .setFontSize(10)
          .text(`${t("Task")}: ${task?.Name}`, margin, yOffset);
        yOffset += 5;
        doc
          .setFontSize(10)
          .text(`${t("Client")}: ${task?.Client?.FullName}`, margin, yOffset);
        yOffset += 5;
        doc
          .setFontSize(10)
          .text(
            `${t("DueDate")}: ${formatDateFromNow(
              task?.DueDate,
              i18n.language,
              DateFormats.ShortDateTimeFormat.momentJsFormat
            )}`,
            margin,
            yOffset
          );
        yOffset += 20;

        comments.forEach((comment) => {
          doc.setTextColor(0, 0, 0);
          const commentText = comment?.Text.replace(/<\/?[^>]+(>|$)/g, "");
          doc.splitTextToSize(`${commentText}`, maxWidth).forEach((line) => {
            addPageIfNeeded(lineHeight);
            doc.text(line, margin, yOffset);
            yOffset += lineHeight;
          });

          doc.setTextColor(117, 117, 117);
          const userName = `${t("By")}: ${comment?.UserFullName}`;
          addPageIfNeeded(lineHeight);
          doc.text(userName, margin, yOffset);
          yOffset += 5;

          const createdDate = `${t("Created")}: ${formatDate(
            comment?.CreatedDate,
            DateFormats.ShortDateTimeFormat.momentJsFormat
          )}`;
          addPageIfNeeded(userInfoSpacing);
          doc.text(createdDate, margin, yOffset);
          yOffset += 10;
          doc.setDrawColor(179, 179, 179);
          doc.line(margin, yOffset, margin + maxWidth, yOffset);

          addPageIfNeeded(10);
          yOffset += 15;
        });

        doc.save("comments.pdf");
      },
    },
  ];

  return (
    <div
      id="dd_task-overlay_comments et-bg-gray"
      className="task-comments-cont tab-item pb-3"
    >
      <div className="d-flex justify-content-start align-items-center gap-1 p-3 bb-1-light-gray">
        <div className="comments-title">{t("Comments")}</div>
        <IconDropDownButton
          id={"moreactions-dropdown"}
          iconCss="fa-regular fa-ellipsis-vertical"
          className="more-actions-dropdown"
          select={onSelectDropDownTaskMenu}
          items={dropdownMenu}
        />
      </div>
      <Comments
        comments={comments}
        task={task}
        refetchComments={refetchComments}
      />
    </div>
  );
};
